export default __webpack_public_path__ + "static/media/bathroom1-after-480w.f847eae0.webp";